<script setup>
/**
 * Seletor de abas da lista de conversas (componente Sutil, 2026-08-14).
 *
 * Por que existe: com 4 abas a barra passou a rolar horizontalmente no painel
 * de ~300px. Em vez de escolher por todo mundo quais abas somem, cada usuario
 * decide a sua -- a Adri esconde uma coisa, o Pedro outra.
 *
 * Onde guarda: ui_settings do proprio usuario, que o Chatwoot ja usa para
 * preferencia de interface (conversation_display_type, paineis abertos etc).
 * Nao precisou de tabela nem de endpoint novo.
 *
 * Arquivo NOVO de proposito: nao conflita em upgrade. O unico contato com o
 * upstream sao duas linhas no ChatTypeTabs.vue.
 */
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';

const props = defineProps({
  items: { type: Array, default: () => [] },
});

const CHAVE = 'sutil_hidden_tabs';
const { uiSettings, updateUISettings } = useUISettings();

const aberto = ref(false);
const raiz = ref(null);

const escondidas = computed(() => uiSettings.value?.[CHAVE] ?? []);

const alternar = chave => {
  const atual = [...escondidas.value];
  const i = atual.indexOf(chave);

  if (i >= 0) {
    atual.splice(i, 1);
  } else {
    // nunca deixar o usuario esconder tudo -- sobraria uma barra vazia
    if (atual.length >= props.items.length - 1) return;
    atual.push(chave);
  }

  updateUISettings({ [CHAVE]: atual });
};

const fecharSeForaDaCaixa = evento => {
  if (raiz.value && !raiz.value.contains(evento.target)) aberto.value = false;
};

onMounted(() => document.addEventListener('click', fecharSeForaDaCaixa));
onBeforeUnmount(() => document.removeEventListener('click', fecharSeForaDaCaixa));
</script>

<template>
  <div ref="raiz" class="relative flex items-center shrink-0">
    <button
      type="button"
      class="flex items-center justify-center transition-colors border rounded-md size-7 border-n-weak bg-n-solid-2 text-n-slate-12 hover:bg-n-alpha-3 hover:border-n-strong"
      :class="aberto && 'bg-n-alpha-3 border-n-strong'"
      :title="$t('CHAT_LIST.TAB_PICKER.TITLE')"
      @click.stop="aberto = !aberto"
    >
      <span class="i-lucide-sliders-horizontal size-[18px]" />
    </button>

    <div
      v-if="aberto"
      class="absolute right-0 z-50 py-1 border rounded-lg shadow-lg top-7 w-52 bg-n-solid-1 border-n-weak"
    >
      <p class="px-3 py-1 text-xs font-medium text-n-slate-10">
        {{ $t('CHAT_LIST.TAB_PICKER.TITLE') }}
      </p>

      <button
        v-for="item in items"
        :key="item.key"
        type="button"
        class="flex items-center w-full gap-2 px-3 py-1.5 text-sm text-left text-n-slate-12 hover:bg-n-alpha-2"
        @click.stop="alternar(item.key)"
      >
        <span
          class="size-4 shrink-0"
          :class="
            escondidas.includes(item.key)
              ? 'i-lucide-square text-n-slate-9'
              : 'i-lucide-square-check text-n-brand'
          "
        />
        <span class="truncate">{{ item.name }}</span>
      </button>
    </div>
  </div>
</template>
